<template>
	<div>
		<h1 class="page-header"><i class="fa-solid fa-house-chimney-user"></i> Vendégház szerkesztése <small></small></h1>
		<div class="row">
			<div class="col-lg-6">
				<panel title="Alapadatok">
					<Loading v-if="!guesthouse"></Loading>
					<NoRecords v-else-if="guesthouse.notfound" main_icon="fa-solid fa-house-chimney-user" title="Nem található a vendégház"></NoRecords>
					<NoRecords v-else-if="users != null && users.length == 0" main_icon="fa-solid fa-users" title="Nem található gondnok felhasználó"></NoRecords>
					<div v-else>
						<form @submit.prevent="updateGuesthouse">
							<div class="form-group">
								<label for="nameInput" class="form-label">Név</label>
								<input type="text" class="form-control" v-model="guesthouse.name" :class="{'is-invalid':errors.name}" id="nameInput"/>
								<div class="invalid-feedback" v-if="errors.name">
									{{errors.name[0]}}
								</div>
							</div>
							<div class="form-group mt-2">
								<div class="row">
									<div class="col-md-4">
										<label for="postcodeInput" class="form-label">Irányítószám</label>
										<input type="text" class="form-control" v-model="guesthouse.postcode" :class="{'is-invalid':errors.name}" id="postcodeInput"/>
										<div class="invalid-feedback" v-if="errors.name">
											{{errors.postcode[0]}}
										</div>
									</div>
									<div class="col-md-8">
										<label for="cityInput" class="form-label">Város</label>
										<input type="text" class="form-control" v-model="guesthouse.city" :class="{'is-invalid':errors.name}" id="cityInput"/>
										<div class="invalid-feedback" v-if="errors.name">
											{{errors.city[0]}}
										</div>
									</div>
								</div>
							</div>
							<div class="form-group mt-2">
								<label for="addressInput" class="form-label">Cím</label>
								<input type="text" class="form-control" v-model="guesthouse.address" :class="{'is-invalid':errors.name}" id="addressInput"/>
								<div class="invalid-feedback" v-if="errors.name">
									{{errors.address[0]}}
								</div>
							</div>
							<div class="form-group mt-2">
								<label for="mapsInput" class="form-label">Google Térkép link</label>
								<input type="text" class="form-control" v-model="guesthouse.google_maps" :class="{'is-invalid':errors.google_maps}" id="mapsInput"/>
								<div class="invalid-feedback" v-if="errors.google_maps">
									{{errors.google_maps[0]}}
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-6 px-auto">
									<div class="form-check form-switch">
										<input class="form-check-input" :class="{'is-invalid':errors.visible}" type="checkbox" id="visibleInput" v-model="guesthouse.visible" :true-value="1" :false-value="0"/>
										<label class="form-check-label form-label" for="visibleInput">Látható</label>
									</div>
									<div class="invalid-feedback" v-if="errors.visible">
										{{errors.visible[0]}}
									</div>
								</div>
								<div class="col-6 px-auto">
									<div class="form-check form-switch">
										<input class="form-check-input" :class="{'is-invalid':errors.apartment}" type="checkbox" id="apartmentInput" v-model="guesthouse.apartment" :true-value="1" :false-value="0"/>
										<label class="form-check-label form-label" for="apartmentInput">Apartman</label>
									</div>
									<div class="invalid-feedback" v-if="errors.apartment">
										{{errors.apartment[0]}}
									</div>
								</div>
							</div>
							<div class="form-group mt-2">
								<label for="ifaInput" class="form-label">Idegenforgalmi adó</label>
								<div class="input-group">
									<span class="input-group-text">Ft</span>
									<input type="text" class="form-control" v-model="guesthouse.ifa" :class="{'is-invalid':errors.ifa}" id="ifaInput"/>
								</div>
								<div class="invalid-feedback" v-if="errors.ifa">
									{{errors.ifa[0]}}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Gondnok</label>
								<Loading mini v-if="!users"></Loading>
								<v-select v-else v-model="guesthouse.user_id" :options="users" :reduce="(option) => option.id" label="name">
									<template #search="{attributes, events}">
										<input
											class="vs__search"
											:required="!guesthouse.user_id"
											v-bind="attributes"
											v-on="events"
											:placeholder="!guesthouse.user_id ? 'Válassz Gondnokot!' : ''"
										/>
									</template>
								</v-select>
							</div>
							<div class="form-group mt-2">
								<label for="descriptionInput" class="form-label">Leírás</label>
								<!-- <textarea cols="30" class="form-control" style="height:400px" v-model="guesthouse.description" :class="{'is-invalid':errors.description}" id="descriptionInput" required></textarea> -->
								<Editor :api-key="tinyMceApiKey"
									:init="{
										plugins: 'lists link image table code help wordcount'
									}"
									v-model="guesthouse.description" 
									:class="{'is-invalid':errors.description}" 
									id="descriptionInput" 
									/>
								<div class="invalid-feedback" v-if="errors.description">
									{{errors.description[0]}}
								</div>
							</div>
							<div class="form-group mt-2">
								<label for="amenitiesInput" class="form-label">Szolgáltatások</label>
								<!-- <textarea cols="30" class="form-control" style="height:400px" v-model="guesthouse.amenities" :class="{'is-invalid':errors.amenities}" id="amenitiesInput"></textarea> -->
								<Editor :api-key="tinyMceApiKey"
									:init="{
										plugins: 'lists link image table code help wordcount'
									}"
									v-model="guesthouse.amenities" 
									:class="{'is-invalid':errors.amenities}" 
									id="amenitiesInput" 
									/>
								<div class="invalid-feedback" v-if="errors.amenities">
									{{errors.amenities[0]}}
								</div>
							</div>
							<div class="form-group mt-2">
								<label for="programsInput" class="form-label">Programajánló</label>								
								<Editor :api-key="tinyMceApiKey"
									:init="{
										plugins: 'lists link image table code help wordcount'
									}"
									v-model="guesthouse.programs" 
									:class="{'is-invalid':errors.programs}" 
									id="programsInput" 
									/>
								<div class="invalid-feedback" v-if="errors.programs">
									{{errors.programs[0]}}
								</div>
							</div>
							<div slot="footer" class="text-end mt-2">
								<button class="btn btn-icon btn-lg btn-success" title="mentés" :disabled="loading">
									<i v-if="loading" class="fa-solid fa-cog fa-spin"></i>
									<i v-else class="fa-solid fa-floppy-disk"></i>
								</button>
							</div>
						</form>
					</div>
				</panel>
				<panel title="szobák">
					<Loading v-if="!rooms"></Loading>
					<NoRecords v-else-if="rooms.length == 0" main_icon="fa-solid fa-door-open" title="Nem találhatóak szobák"></NoRecords>
					<div v-else class="table-responsive">
						<table class="table table-striped table-hover">
							<thead>
								<tr>
									<th>Szám</th>
									<th>Fantázianév</th>
									<th>Kapacitás</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(room,id) in rooms" :key="id">
									<td>{{room.number}}</td>
									<td>{{room.name}}</td>
									<td>{{room.capacity}} fő</td>
									<td>
										<router-link :to="'/rooms/'+room.id+'/edit'" class="btn btn-warning btn-sm mx-1" title="szerkesztés"><i class="fa fa-edit"></i></router-link>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</panel>
			</div>
			<div class="col-lg-6">
				<panel title="Képek">
					<Loading v-if="!guesthouse"></Loading>
					<ImageUpload v-else parent_model="Guesthouse" :model_id="guesthouse.id"></ImageUpload>
				</panel>
				<panel title="Nyitvatartás">
					<Loading v-if="!guesthouse"></Loading>
					<NoRecords v-else-if="guesthouse.notfound" main_icon="fa-solid fa-calendar-xmark" title="Nyitvatartás betöltése sikertelen"></NoRecords>
					<div v-else>
						<div class="row">
							<div class="col text-center">
								<h5>Az adott hónapokra vonatkozó nyitvatartást az alábbi színkódok jelzik:</h5>
								<span>
									<i class="fa fa-circle text-lime"></i>
									nyitva
								</span>
								<span class="ms-2">
									<i class="fa fa-circle text-muted"></i>
									zárva
								</span>
							</div>
						</div>
						<hr>
						<div class="row">
							<div class="col-2 my-2" v-for="(month,id) in guesthouse.open_months" :key="id">
								<span class="fa-stack fa-2x">
									<i class="fa fa-square fa-stack-2x" :class="{'text-lime': month == 1,'text-muted': month != 1}"></i>
									<i class="fa-solid fa-stack-1x fa-inverse">{{id}}</i>
								</span>
							</div>
						</div>
					</div>
				</panel>
			</div>
		</div>
	</div>
</template>

<script>
	import ImageUpload from '../../components/ImageUpload';
	import Guesthouse from '../../apis/Guesthouse';
	import User from '../../apis/User';
	import Editor from '@tinymce/tinymce-vue'
	export default {
		name:'EditGuesthouse',
		components:{
			ImageUpload,
			Editor
		},
		data() {
			return {
				guesthouse:null,
				rooms:null,
				users:null,
				loading:false,
				errors:[],
				tinyMceApiKey: process.env.VUE_APP_TINY_MCE_API_KEY
			}
		},
		created() {
			Guesthouse.show(this.$route.params.id)
			.then(response => {
				this.guesthouse = response.data;
			}).catch(() => {
				this.guesthouse = {notfound:true}
			});
			Guesthouse.rooms(this.$route.params.id)
			.then(response => {
				this.rooms = response.data;
			}).catch(() => {
				this.rooms = [];
			});
			User.getRole(2)
			.then(response => {
				this.users = response.data
			}).catch(() => {
				this.users = []
			})
		},
		methods: {
			updateGuesthouse(){
				this.loading = true;
				Guesthouse.update(this.$route.params.id,this.guesthouse)
				.finally(() => {
					this.loading = false;
				})
			}
		}
	};
</script>

<style>
#descriptionInput, #amenitiesInput, #programsInput{
	height:600px;
}
</style>